export function addAnalyticsDataAttributes({ category, action = '', label, value, trackSwipe, }) {
    const base = {
        'data-analytics-category': category,
        'data-analytics-action': action,
        'data-analytics-label': label,
        'data-analytics-value': value,
        'data-analytics-track-swipe': trackSwipe,
    };
    return base;
}
//# sourceMappingURL=analytics.js.map